<ion-header>
  <ion-toolbar color="white-0">
    <ion-title>Account restriction notice</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="mable-section">
    <div class="ion-padding-horizontal">
      <p>Your account has been restricted due to activities that breach</p>
      <mable-button
        category="link"
        class="ion-no-padding"
        (onClick)="openLink('https://mable.com.au/terms-of-use/#anti-avoidance')"
      >
        Mable's terms of use
      </mable-button>
      <p>
        Some account features are temporarily unavailable. This will not affect communication and support arrangements
        with existing clients or workers. We've sent you an email with further information. If you believe an error has
        been made, contact us at:
      </p>
      <mable-button
        category="link"
        class="ion-no-padding"
        (onClick)="openLink('mailto:trustandsafety@mable.com.au')"
      >
        trustandsafety&#64;mable.com.au
      </mable-button>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <mable-button
      category="orange-500"
      expand="block"
      (onClick)="closeModal()"
      >Close
    </mable-button>
  </ion-toolbar>
</ion-footer>
